import { ensureNotNil } from '@studio/js-utils';
import type { User } from '@studio/models/user';
import type { EqualityFn, SelectorFn } from '@studio/react-utils/store';
import { useDepot } from '#~/depot/hooks.js';

/**
 * Returns a reactive slice of the application user.
 *
 * @param selectorFn - Slice selector.
 * @param equalityFn - Slice equality function.
 * @returns Selected slice.
 */
export const useUser = <Slice>(
  selectorFn: SelectorFn<User, Slice>,
  equalityFn?: EqualityFn<Slice>
): Slice => useDepot((µ) => selectorFn(ensureNotNil(µ.user)), equalityFn);
